import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getResearchHistory } from "../lib/api";
import { ArrowUpRight, Package } from "lucide-react";

const STATUS_COLORS = {
  completed: "bg-emerald-500",
  failed: "bg-red-500",
  pending: "bg-zinc-400",
  scanning_tiktok: "bg-[#002FA7]",
  scanning_instagram: "bg-[#002FA7]",
  scanning_cj: "bg-[#002FA7]",
  analyzing: "bg-[#002FA7]",
};

export default function HistoryPage() {
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    getResearchHistory().then(setJobs).catch(() => setJobs([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="mb-10">
        <div className="micro-label mb-3">ARCHIVE</div>
        <h1 className="text-5xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>
          Research History
        </h1>
      </div>

      {jobs === null && <div className="micro-label">LOADING...</div>}
      {jobs?.length === 0 && (
        <div className="border border-zinc-200 p-16 text-center">
          <Package size={48} className="mx-auto mb-4 text-zinc-300" strokeWidth={2} />
          <p className="text-zinc-600 mb-6">No research jobs yet.</p>
          <Link to="/admin" className="btn-klein inline-block text-xs">RUN FIRST RESEARCH</Link>
        </div>
      )}

      {jobs?.length > 0 && (
        <div className="border border-zinc-200" data-testid="history-list">
          {jobs.map((j, idx) => (
            <Link
              key={j.id}
              to={`/admin/research/${j.id}`}
              data-testid={`history-item-${idx}`}
              className={`flex items-center justify-between p-5 md:p-6 hover:bg-zinc-50 transition ${
                idx < jobs.length - 1 ? "border-b border-zinc-200" : ""
              }`}
            >
              <div className="flex items-center gap-5 min-w-0">
                <div className={`w-2 h-2 rounded-full ${STATUS_COLORS[j.status] || "bg-zinc-400"}`} />
                <div className="min-w-0">
                  <div className="font-black text-lg tracking-tight truncate" style={{ fontFamily: "Outfit" }}>
                    {j.niche === "home_decor" ? "Home Decor" : "Gadgets / Tech"}
                  </div>
                  <div className="micro-label mt-0.5">
                    {new Date(j.created_at).toLocaleString()} · {j.status.replace("_", " ").toUpperCase()}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-6">
                {j.status === "completed" && (
                  <div className="hidden md:block">
                    <div className="micro-label">Products</div>
                    <div className="text-2xl font-black" style={{ fontFamily: "Outfit" }}>
                      {j.products?.length || 0}
                    </div>
                  </div>
                )}
                <ArrowUpRight size={20} strokeWidth={2.5} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
